import jwtDecode from 'jwt-decode';
import cookie from 'react-cookies';

// ------------------------------------
// Constants
// ------------------------------------
export const UPDATE_NAME = 'UPDATE_NAME';
export const AUTH_USER = 'AUTH_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

// ------------------------------------
// Helper
// ------------------------------------

const getAuthToken = (Token = undefined) => {
    const CookieToken = Token || cookie.load('token');

    if (CookieToken !== undefined) {
        let Token = jwtDecode(CookieToken);

        if (Token.exp > Date.now()) {
            Token = {};
        }

        Bugsnag.user = Token;
        window.AuthUser = Token;

        return Object.assign({}, Token, {
            rawToken: CookieToken
        });
    }

    return {};
};

// ------------------------------------
// Actions
// ------------------------------------
export function updateName(newName = '') {
    cookie.save('first_name', newName);
    return {
        type: UPDATE_NAME,
        payload: newName
    };
}

export function authenticateUser(newToken = '') {
    cookie.save('token', newToken, {
        path: '/',
        maxAge: (60 * 60 * 3),
    });
    return {
        type: AUTH_USER,
        payload: newToken
    };
}

export function logoutUser() {
    console.log('Logout');
    cookie.remove('token', {
        path: '/',
    });
    return {
        type: LOGOUT_USER
    };
}

export const actions = {
    updateName,
    authenticateUser,
    logoutUser,
};

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
    [UPDATE_NAME]: (state, action) => Object.assign({}, state, {
        firstName: action.payload,
    }),
    [AUTH_USER]: (state, action) => Object.assign({}, state, getAuthToken(action.payload)),
    [LOGOUT_USER]: (state, action) => Object.assign({}, getAuthToken(), {
        firstName: undefined,
    }),
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = Object.assign({}, getAuthToken(), {
    firstName: cookie.load('first_name'),
});

export default function authReducer(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/auth.js